import { FormattedMessage } from 'react-intl';

import { Season26TutorialDialog } from '@sorare/core/src/components/dialog/Season26TutorialDialog';
import { Season26TutorialStep } from '@sorare/core/src/components/dialog/Season26TutorialStep';
import { glossary } from '@sorare/core/src/lib/glossary';

import { QuickPlayTutorialHeader } from 'components/quickPlay/QuickPlayTutorialHeader';

import { GetRewarded } from './GetRewarded';
import { HitScoreTarget } from './HitScoreTarget';
import { StartStreak } from './StartStreak';
import { QuickPlayTutorialFooter } from '../QuickPlayTutorialFooter';
import type { QuickPlayTutorialDialogType } from '../types';
import background from './assets/background.webp';

type Props = {
  open: boolean;
  onContinue: () => void;
  loading: boolean;
  onSelect: (type: QuickPlayTutorialDialogType) => void;
  disableAnimation: boolean;
};
export const IntroducingQuickPlayDialog = ({
  open,
  onContinue,
  loading,
  onSelect,
  disableAnimation,
}: Props) => {
  return (
    <Season26TutorialDialog
      open={open}
      onClose={onContinue}
      color="var(--c-gradient-solana)"
      textColor="var(--c-black)"
      headerBackgroundUrl={background}
      disableAnimation={disableAnimation}
      hideTextureBackground
      gap={2}
      titleGroup={
        <QuickPlayTutorialHeader
          overline={<FormattedMessage {...glossary.introducing} />}
          title={<FormattedMessage {...glossary.quickPlay} />}
        />
      }
      items={[
        <Season26TutorialStep stepNb={1} key="1" fullHeight={!disableAnimation}>
          <HitScoreTarget />
        </Season26TutorialStep>,
        <Season26TutorialStep stepNb={2} key="2" fullHeight={!disableAnimation}>
          <GetRewarded />
        </Season26TutorialStep>,
        <Season26TutorialStep stepNb={3} key="3" fullHeight={!disableAnimation}>
          <StartStreak />
        </Season26TutorialStep>,
      ]}
      footer={
        <QuickPlayTutorialFooter
          onSelect={onSelect}
          onContinue={onContinue}
          loading={loading}
          selectedType="quickPlay"
        />
      }
    />
  );
};
